import React, { useEffect, useState } from "react";
import { ClipboardCheck, CalendarClock, HelpCircle, FileText, StickyNote, AlertTriangle, CreditCard, UserCheck } from "lucide-react";
import { toast } from "sonner";
import api, { fmtDate, formatErr } from "../../lib/api";
import { Loading, EmptyState, PageHeader } from "../../components/Shared";

const ICONS = {
  visit_completed: ClipboardCheck, visit_started: ClipboardCheck, report_ready: FileText,
  appointment: CalendarClock, request: HelpCircle, note: StickyNote,
  incident: AlertTriangle, emergency: AlertTriangle, billing: CreditCard,
  assignment: UserCheck, document: FileText, profile: FileText,
};

export default function Timeline() {
  const [events, setEvents] = useState(null);
  const [note, setNote] = useState("");
  const load = () => api.get("/family/timeline").then((r) => setEvents(r.data));
  useEffect(() => { load().catch(() => setEvents([])); }, []);
  const addNote = async (e) => {
    e.preventDefault();
    try { await api.post("/family/timeline/note", { text: note }); setNote(""); toast.success("Note added"); load(); }
    catch (err) { toast.error(formatErr(err)); }
  };
  if (!events) return <Loading />;
  return (
    <div data-testid="timeline-page">
      <PageHeader title="Care Timeline" sub="Everything that has happened — visits, appointments, requests, notes and reports, in order." />
      <form onSubmit={addNote} className="p1-card mb-6 flex gap-3 p-4" data-testid="add-note-form">
        <input className="p1-input" placeholder="Add a family note (e.g. 'Mom sounded happy on the call today')" value={note} onChange={(e) => setNote(e.target.value)} data-testid="note-input" />
        <button className="p1-btn-primary shrink-0 !px-5" data-testid="note-submit">Add note</button>
      </form>
      {events.length === 0 ? <EmptyState title="No activity yet" body="Once visits and services begin, everything will appear here in plain language." /> : (
        <ol className="relative ml-3 space-y-6 border-l-2 border-stone-200 pl-6">
          {events.map((e) => {
            const Icon = ICONS[e.type] || StickyNote;
            const danger = e.type === "incident" || e.type === "emergency";
            return (
              <li key={e.id} className="relative" data-testid={`timeline-event-${e.id}`}>
                <span className={`absolute -left-[35px] flex h-7 w-7 items-center justify-center rounded-full border-2 border-white ${danger ? "bg-red-100 text-red-600" : "bg-emerald-100 text-emerald-800"}`}>
                  <Icon className="h-3.5 w-3.5" />
                </span>
                <p className="text-xs text-stone-400">{fmtDate(e.at)}</p>
                <p className="font-heading font-semibold text-stone-900">{e.title}</p>
                {e.detail && <p className="text-sm text-stone-600">{e.detail}</p>}
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
}
